import { render, staticRenderFns } from "./PerseoLayout.vue?vue&type=template&id=38092e67&scoped=true"
import script from "./PerseoLayout.vue?vue&type=script&lang=js"
export * from "./PerseoLayout.vue?vue&type=script&lang=js"
import style0 from "./PerseoLayout.vue?vue&type=style&index=0&id=38092e67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38092e67",
  null
  
)

export default component.exports